<template>
<div class="chapter">
<div class="inner_page">
<section class="spart" epub:type="division" id="spart-001"><span epub:type="pagebreak" id="page_14" title="14"><div class="spart_debut"></div><div class="dev"><figure class="fig" id="fig-003"><div class="image"><img alt="The lighthouse top at Watchet Harbour: the beacon of vision, the light of reason, and a lifelong delight in philosophy." class="image" src="images/pg_14_Lighthouse.jpg"/></div><figcaption class="leg"><p class="txt_courant_ssalinea">The lighthouse top at Watchet Harbour: the beacon of vision, the light of reason, and a lifelong delight in philosophy.</p></figcaption></figure></div></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1sp1.vue?60e11b83